// Embed integration exports
export { PaymentCheckout } from '../PaymentCheckout';
export { EventEmitter } from '../events/EventEmitter';

// Type exports
export type {
  CheckoutConfig,
  CheckoutState,
  CheckoutEvents,
  CheckoutEventName,
  CheckoutEventListener,
  CustomizationParams,
  Theme,
  ProductLayout,
} from '../types';

// Class and enum exports
export { PaymentError, PaymentErrorCode } from '../types';

// Embed-specific utilities
import { PaymentCheckout as PaymentCheckoutClass } from '../PaymentCheckout';
export const createEmbeddedCheckout = (element: HTMLElement, config: any) => {
  return PaymentCheckoutClass.fromElement(element, config);
};

// Global constructor and script loading
export { initializeGlobalConstructor } from './globalConstructor';
export { 
  loadScript, 
  loadCheckoutScript, 
  setupGlobalInitialization,
  isCheckoutLoaded,
  waitForCheckout 
} from './scriptLoader';


// Auto-initialize global constructor
if (typeof window !== 'undefined') {
  import('./globalConstructor').then(({ initializeGlobalConstructor }) => {
    initializeGlobalConstructor();
  });
} 